import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRef, forwardRef, useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import * as variants from './styles';
export const DropDown = /*#__PURE__*/ forwardRef(({ children, onClose, onKeyDown, onOptionSelect, options, renderAs, variant = 'base', ...props }, ref)=>{
    const [isOpen, setIsOpen] = useState(false);
    const optionsRef = useRef(null);
    const optionRefs = useMemo(()=>options.map(()=>/*#__PURE__*/ createRef()), [
        options
    ]);
    const { DropDownContainer, DropDownContent, DropDownRoot, NoResult, Option, Options } = variants[variant];
    const toggleIsOpen = useCallback((isOpen)=>{
        setIsOpen(isOpen);
        if (!isOpen) {
            onClose?.();
        }
    }, [
        onClose
    ]);
    useImperativeHandle(ref, ()=>({
            close: ()=>toggleIsOpen(false),
            open: ()=>toggleIsOpen(true)
        }), [
        toggleIsOpen
    ]);
    const focusOption = (index)=>{
        const optionElement = optionRefs[index]?.current;
        if (optionElement) {
            optionElement?.focus();
            optionsRef.current?.scrollTo({
                behavior: 'smooth',
                top: optionElement.offsetTop - (optionsRef.current.getBoundingClientRect().height - optionElement.getBoundingClientRect().height) / 2
            });
        }
        toggleIsOpen(index >= 0);
    };
    const clearInput = ()=>{
        focusOption(-1);
        onOptionSelect('');
    };
    const handleKey = (event, actions)=>{
        const action = actions[event.key];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action();
        }
        onKeyDown?.(event);
    };
    const handleOuterKeyDown = (event)=>{
        const moveDown = ()=>focusOption(0);
        const moveUp = ()=>focusOption(options.length - 1);
        handleKey(event, {
            ArrowUp: moveUp,
            ArrowDown: moveDown,
            Escape: clearInput
        });
    };
    const handleInnerKeyDown = (index, event)=>{
        const moveDown = ()=>focusOption((index + 1) % options.length);
        const moveUp = ()=>focusOption(index - 1);
        const selectCurrent = ()=>onOptionSelect(options[index].value);
        const closeDropdown = ()=>toggleIsOpen(false);
        handleKey(event, {
            ArrowUp: moveUp,
            ArrowDown: moveDown,
            Enter: selectCurrent,
            ' ': selectCurrent,
            Tab: closeDropdown
        });
    };
    return /*#__PURE__*/ _jsxs(DropDownRoot, {
        as: renderAs,
        "data-open": isOpen || undefined,
        onKeyDown: handleOuterKeyDown,
        ...props,
        children: [
            children,
            /*#__PURE__*/ _jsx(DropDownContainer, {
                children: /*#__PURE__*/ _jsx(DropDownContent, {
                    children: /*#__PURE__*/ _jsxs(Options, {
                        "data-testid": "options",
                        ref: optionsRef,
                        children: [
                            options.length === 0 && /*#__PURE__*/ _jsx(NoResult, {
                                children: "Dazu wurde leider kein Eintrag gefunden."
                            }),
                            options.map(({ label, value }, index)=>/*#__PURE__*/ _jsx(Option, {
                                    onClick: ()=>onOptionSelect(value),
                                    onKeyDown: (event)=>handleInnerKeyDown(index, event),
                                    ref: optionRefs[index],
                                    children: label ?? value
                                }, label + value))
                        ]
                    })
                })
            })
        ]
    });
});

//# sourceMappingURL=DropDown.js.map